export var DEPLOY_DATE = new Date('2026-08-13T13:44:37+0000');
